<template>
    <div class="ruleListBox">
        <md-field>
            <md-cell-item v-for="(item) in ruleData" :title="item.topic" :key="item.id" @click="gotoRule(item)"  arrow />
            <md-cell-item v-for="(item2) in ruleData2" :title="item2.topic" :key="item2.id" @click="gotoRule2(item2)"  arrow />
        </md-field>
    </div>
</template>

<script>
    export default {
        name: "memberRuleList",
        data(){
          return{
              ruleData:[],
              ruleData2:[]
          }
        },
        mounted() {
            document.title = "会员规则"
            this.$http.get('/sangto-wrm/base/content/page',{
                params:{
                    contentClass:'MEMBER_RULE',
                    status:2
                }
            } ).then(({data})=>{

                this.ruleData =data.data.rows
            })
            let dt = new URLSearchParams()
            dt.append('contentClass', 'MEMBER_RULE')
            dt.append('status', 2)
            this.$http.post('/system/base/content/page', dt).then(({data})=>{

                this.ruleData2 =data.data.rows
            })
        },
        methods:{
            gotoRule(item){
                this.$router.push({path:'/memberRule', query:{itemData:JSON.stringify(item)}})
            },
            gotoRule2(item){
                this.$router.push({path:'/memberRule2', query:{itemData:JSON.stringify(item)}})
            }
        }
    }
</script>

<style scoped lang="scss">
.ruleListBox{
    position: relative;
    width: 100%;
    height: 100%;
    background-color: #fff;
}
</style>
